import { cn } from '@/lib/utils';
import { DotIndicator } from '@/components/uiKit/DotIndicator';
import { CheckIcon } from 'lucide-react';
import React from 'react';

interface SubComponentCardProps {
  health_status?: any;
  title: string;
  isSelected: boolean;
  onClick: any;
  classNames?: {
    title?: string;
    titleWrapper?: string;
    container?: string;
  };
}

export default function SubComponentCard({
  health_status,
  title,
  isSelected,
  onClick,
  classNames,
}: SubComponentCardProps) {
  return (
    <div
      className={cn(
        'h-full flex items-center justify-between py-3 px-4 border-b-2 border-gray-200 hover:opacity-80 hover:cursor-pointer',
        classNames?.container
      )}
      onClick={onClick}
    >
      <div className={cn('gap-4 flex items-center max-w-[90%]', classNames?.titleWrapper)}>
        {health_status && <DotIndicator status={health_status} />}
        <span className="w-full text-ellipsis whitespace-nowrap block overflow-hidden">{title}</span>
      </div>

      {isSelected && (
        <div>
          <CheckIcon size={16} />
        </div>
      )}
    </div>
  );
}
